module.exports = __webpack_public_path__ + "3c1295d92a916b07ed2df8bd5e099167.png";